module.exports = __webpack_public_path__ + "img/image.9355d4ed.svg";